function findInEnumType(enumObject, index, getKey) {
    if (typeof enumObject[index] !== 'undefined') {
        if (getKey) {
            if (getKey === true) {
                return enumObject[index]['key']
            } else {
                if (typeof enumObject[index][getKey] !== 'undefined') {
                    return enumObject[index][getKey]
                } else {
                    return null
                }
            }
        } else {
            return enumObject[index]['fa']
        }
    }
    return null;
}


export function genderEnum() {
    return findInEnumType({
        'male': {key: 'male', fa: ('آقا'), selfMode: ('آقای'), color: 'text-blue-600'},
        'female': {key: 'female', fa: ('خانم'), selfMode: ('خانم'), color: 'text-pink-600'},
    }, ...arguments)

}


export function maritalEnum() {
    return findInEnumType({
        'single': {key: 'single', fa: 'مجرد', color: 'text-blue-600'},
        'married': {key: 'married', fa: 'متاهل', color: 'text-pink-600'},
    }, ...arguments)
}


export function lessonRegisterStatusEnum() {
    return findInEnumType({
        'remove': {key: 'remove', fa: 'حذف شده', color: 'text-red-600'},
        'taken': {key: 'taken', fa: 'اخذ شده', color: 'text-green-600'},
        'removeadmin': {key: 'removeadmin', fa: 'حذف شده توسط مدیر', color: 'text-red-600'},
        'add': {key: 'add', fa: 'اضافه شده', color: 'text-green-600'},
        'removeforce': {key: 'removeforce', fa: 'حذف شده اضطراری', color: 'text-red-600'},
        'cancel': {key: 'cancel', fa: 'لغو شده', color: 'text-gray-600'},
        'reserve': {key: 'reserve', fa: 'رزرو شده', color: 'text-yellow-600'}
    }, ...arguments)
}


export function InstallmentPayStatusEnum() {
    return findInEnumType({
        'pending': {key: 'pending', fa: 'در انتظار', color: 'text-blue-600'},
        'full_payed': {key: 'full_payed', fa: 'پرداخت شده', color: 'text-green-600'},
        'inventory_deduction': {key: 'inventory_deduction', fa: 'کسر از حساب', color: 'text-yellow-600'},
    }, ...arguments)
}


export function AbsenceTypeEnum() {
    return findInEnumType({
        'absent': {key: 'absent', fa: 'غیبت', color: 'text-red-600'},
        'late': {key: 'late', fa: 'تاخیر', color: 'text-blue-600'},
        'present': {key: 'present', fa: 'حاضر', color: 'text-green-600'},
        'excused': {key: 'excused', fa: 'موجه', color: 'text-yellow-600'},
    }, ...arguments)
}


export function DiscountCodeStatusEnum() {
    return findInEnumType({
        draft: {key: 'draft', fa: 'پیش نویس', color: ''},
        publish: {key: 'publish', fa: 'منتشر شده', color: 'text-green-600'},
        expire: {key: 'expire', fa: 'منقضی شده', color: 'text-red-600'},
        full: {key: 'full', fa: 'استفاده کامل', color: 'text-blue-600'},
        disable: {key: 'disable', fa: 'غیرفعال', color: 'text-gray-600'},

    }, ...arguments)
}


export function ClassroomCodeStatusEnum() {
    return findInEnumType({
        draft: {key: 'draft', fa: 'پیش نویس', color: ''},
        enable: {key: 'enable', fa: 'فعال', color: 'text-green-600'},
        disable: {key: 'disable', fa: 'غیرفعال', color: 'text-gray-600'},

    }, ...arguments)
}


export function RefundStatusEnum() {
    return findInEnumType({
        pending: {key: 'pending', fa: 'در انتظار', color: 'blue'},
        approved: {key: 'approved', fa: 'تایید شده', color: 'blue'},
        rejected: {key: 'rejected', fa: 'رد شده', color: 'red'},
        cancelled: {key: 'cancelled', fa: 'لغو شده', color: 'red'},
        payed: {key: 'payed', fa: 'پرداخت شده', color: 'green'},


    }, ...arguments)
}

export function GroupStatusEnum() {
    return findInEnumType({
        enable: {key: 'enable', fa: 'فعال', color: 'bg-green-100 text-green-700'},
        disable: {key: 'disable', fa: 'غیرفعال', color: 'bg-red-100 text-red-700'},
    }, ...arguments)
}

export function GradeStatusEnum() {
    return findInEnumType({
        enable: {key: 'enable', fa: 'فعال', color: 'bg-green-100 text-green-700'},
        disable: {key: 'disable', fa: 'غیرفعال', color: 'bg-red-100 text-red-700'},
    }, ...arguments)
}

export function SignupStatusEnum() {
    return findInEnumType({
        true: {key: true, fa: 'باز', color: 'bg-green-100 text-green-700'},
        false: {key: false, fa: 'بسته', color: 'bg-red-100 text-red-700'},
    }, ...arguments)
}

export function HomeworkStatusEnum() {
    return findInEnumType({
        draft: {key: 'draft', fa: 'پیش نویس', color: ''},
        enable: {key: 'enable', fa: 'فعال', color: 'text-green-600'},
        expire: {key: 'expire', fa: 'منقضی شده', color: 'text-red-600'},
        disable: {key: 'disable', fa: 'غیرفعال', color: 'text-gray-600'},

    }, ...arguments)
}

export function TeacherTimesStatusEnum() {
    return findInEnumType({
        error: {key: 'error', fa: 'خطا', color: 'text-red-600'},
        accept: {key: 'accept', fa: 'تایید شده', color: 'text-green-600'},
    }, ...arguments)
}


export function TeacherReportStatusEnum() {
    return findInEnumType({

        accept: {key: 'accept', fa: 'تایید شده', color: 'text-green-600'},
        reject: {key: 'reject', fa: 'رد شده', color: 'text-red-600'},
        awaiting: {key: 'awaiting', fa: 'در انتظار', color: 'text-blue-600'},
    }, ...arguments)
}

export function TeacherTimesTypeEnum() {
    return findInEnumType({
        teachertime: {key: 'teachertime', fa: 'زمان ثبت شده توسط مربی', color: 'text-red-600'},
        adminchange: {key: 'adminchange', fa: 'تغییرات مدیریت', color: 'text-red-600'},
        via_report: {key: 'via_report', fa: 'با ثبت گزارش', color: 'text-red-600'},
        moderator: {key: 'moderator', fa: 'ناظم', color: 'text-green-600'},
    }, ...arguments)
}


export function DiscountCodeModeEnum() {
    return findInEnumType({
        percent: {key: 'percent', fa: 'درصدی', color: ''},
        amount: {key: 'amount', fa: 'مبلغ ثابت', color: ''},


    }, ...arguments)
}


export function permissionModuleEnum() {
    return findInEnumType({
        'group': {key: 'group', fa: 'گروه‌های علمی', color: 'blue'},
        'grade': {key: 'grade', fa: 'مقاطع تحصیلی', color: 'blue'},
        'course': {key: 'course', fa: 'رشته‌ها', color: 'blue'},
        'topic': {key: 'topic', fa: 'سرفصل ها', color: 'blue'},
        'certification': {key: 'certification', fa: 'گواهی‌نامه‌ها', color: 'blue'},
        'classroom': {key: 'classroom', fa: 'محل برگزاری کلاس', color: 'blue'},
        'refund': {key: 'refund', fa: 'بازگشت وجه', color: 'blue'},
        'lesson': {key: 'lesson', fa: 'درس‌ها', color: 'blue'},
        'member': {key: 'member', fa: 'اعضاء', color: 'blue'},
        'discount': {key: 'discount', fa: 'کدتخفیف', color: 'blue'},
        'survey': {key: 'survey', fa: 'نظرسنجی', color: 'blue'},
        'roles': {key: 'roles', fa: 'سطح دسترسی', color: 'blue'},
        'settings': {key: 'settings', fa: 'تنظیمات', color: 'blue'},
        'exports': {key: 'exports', fa: 'خروجی', color: 'blue'},
        'import': {key: 'import', fa: 'ایمپورت', color: 'blue'},
        'product': {key: 'product', fa: 'محصولات', color: 'blue'},

    }, ...arguments)
}


export function MemberStatusEnum() {
    return findInEnumType({
        active: {key: 'active', fa: 'فعال', color: 'green'},
        awaiting: {key: 'awaiting', fa: 'در انتظار', color: 'yellow'},
        removed: {key: 'removed', fa: 'حذف شده', color: 'red'},
        filter: {key: 'filter', fa: 'مسدود شده', color: 'purple'},


    }, ...arguments)
}




